<template functional>
  <div :class="[props.classList, 'chip-smaller']">
    <v-chip label :color="$options.chipColor(props.value.status)">
      <span v-if="props.value.status" class="white--text">
        {{
          parent.$t(
            `common:paymentStatus.${props.value.status.toUpperCase()}`,
            props.value.status
          )
        }}
      </span>
    </v-chip>

    <b>
      <v-tooltip v-if="props.loadingIcon" bottom>
        <template #activator="{ on, attrs}">
          <div v-bind="attrs" v-on="on">
            <v-progress-circular
              indeterminate
              aria-label="refresh"
              color="grey"
              size="14"
              width="2"
            />
          </div>
        </template>
        <span>Refreshes in every 15 seconds</span>
      </v-tooltip>
    </b>
    <div v-if="props.withDetails" class="status-date">
      {{ parent.$dayjs.date($options.statusDate(props.value)) }}
      <br />
      <span v-if="$options.statusDate(props.value)" class="muted--text">
        {{ parent.$dayjs($options.statusDate(props.value)).format("HH:mm:ss") }}
      </span>
    </div>
  </div>
</template>
<script>
import gql from "fraql";
export default {
  name: "AppShowPaymentStatus",
  props: {
    value: {
      type: Object,
      required: true
    },
    withDetails: {
      type: Boolean,
      default: false
    },
    loadingIcon: {
      type: Boolean,
      default: false
    },
    classList: {
      type: String,
      default: undefined
    }
  },
  statusClass(object) {
    switch (object.status) {
      case "PENDING":
        return "edit--text";
      case "PAID":
        return "edit-green--text";
      case "CANCELLED":
        return "edit--text";
      case "FULLY_REFUNDED":
        return "white--text";
      case "PARTIALLY_REFUNDED":
        return "white--text";
      default:
        return "";
    }
  },
  statusDate(obj) {
    switch (obj.status) {
      case "FULLY_REFUNDED":
      case "PARTIALLY_REFUNDED":
        return obj.refundedAt;
      case "PAID":
        return obj.confirmedAt;
      default:
        return obj.createdAt;
    }
  },
  chipColor(status) {
    switch (status) {
      case "NOT_PAID":
        return "secondary";
      case "IN_PROGRESS":
      case "PENDING":
      case "WARNING":
      case "CANCELLED":
        return "edit";
      case "PAID":
        return "edit-green";
      case "FULLY_REFUNDED":
        return "grey";
      case "PARTIALLY_REFUNDED":
        return "grey";
      default:
        return "grey";
    }
  },
  fragments: {
    payment: gql`
      fragment _ on Payment {
        status
        createdAt
        confirmedAt
        cancelledAt
        refundedAt
      }
    `
  }
};
</script>
